import script from "./cardMoudle3.vue?vue&type=script&setup=true&lang=js"
export * from "./cardMoudle3.vue?vue&type=script&setup=true&lang=js"

import "./cardMoudle3.vue?vue&type=style&index=0&id=4946bffd&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4946bffd"]])

export default __exports__